import { FormArray, ValidatorFn } from "@angular/forms";
import { FormService } from "../form.service";
import { MAX_CLAIM_AMOUNT_HUF } from "./claim-amount-huf";

export function totalAmountValidator(
  amountName: string,
  currencyName: string,
  formService: FormService
): ValidatorFn {
  return arr => {
    if (!(arr instanceof FormArray)) {
      return null;
    }
    const totalAmount = arr.controls.reduce((sum, control) => {
      const amount = control.value[amountName] as string | number | null;
      const currency = control.value[currencyName] as string | null;
      if (!amount || !currency) {
        return sum;
      }

      const huf = formService.convertClaimAmountToHuf(+amount, currency);
      return sum + huf;
    }, 0);

    if (totalAmount > MAX_CLAIM_AMOUNT_HUF) {
      return {
        max: {
          max: MAX_CLAIM_AMOUNT_HUF,
          actual: totalAmount,
        },
      };
    }
    return null;
  };
}